
  import { computed, defineComponent, ref } from "vue"
  import { useI18n } from "vue-i18n"
  import { Router, useRoute, useRouter } from "vue-router"
  import { useStore } from "vuex"
  import ChooseLang from "./ChooseLang.vue"
  import "./scss/header/Header.scss"

  export default defineComponent({
    name: "Header",
    components: { ChooseLang },
    setup(props, ctx) {
      const store = useStore()
      const router: Router = useRouter()
      const route = useRoute()

      const id = computed(() => store.getters.userID)

      const { t } = useI18n({ useScope: 'global' })

      const menu = ref<any>(null)
      const panelLogo = ref<any>(null)

      const logout = () => store.dispatch("logout")
      const openPanel = () => {
        menu.value.classList.toggle("menu__active")
        panelLogo.value.classList.toggle("menu__panel-active")
      }

      const handleLink = () => {
        if (route.name == "Account" && route.params.id != id.value) router.push({ name: "Account", params: { id: id.value }, replace: true }).then(() => window.location.reload())
        else router.push({ name: "Account", params: { id: id.value }})
      }

      router.beforeEach((to, from) => {
        menu.value.classList.remove("menu__active")
        panelLogo.value.classList.remove("menu__panel-active")
      })

      return {
        t, id, logout, openPanel, menu, panelLogo, isAuth: computed(() => store.getters.isAuth), handleLink,
      }
    },
  })
